/* Custom Modal - Ensure is-locked stays while modal is open */
(function() {
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'aria-hidden') {
        var modal = mutation.target;
        if (modal.id && modal.id.indexOf('custom-modal-') === 0) {
          var isOpen = modal.getAttribute('aria-hidden') === 'false';
          if (isOpen) {
            document.documentElement.classList.add('is-locked');
          } else {
            // Only remove is-locked if no other custom modals are open
            var openModals = document.querySelectorAll('.modal[id^="custom-modal-"][aria-hidden="false"]');
            if (openModals.length === 0) {
              document.documentElement.classList.remove('is-locked');
            }
          }
        }
      }
    });
  });

  // Observe all custom modals for aria-hidden changes
  function observeModals() {
    var modals = document.querySelectorAll('.modal[id^="custom-modal-"]');
    modals.forEach(function(modal) {
      observer.observe(modal, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeModals);
  } else {
    observeModals();
  }
})();
